import React, { FC, useState } from 'react'
import { InView } from 'react-intersection-observer'

import { StyledLogo } from './AnimatedLogo.sc'

const AnimatedLogo: FC = () => {
  const [animate, setAnimation] = useState<boolean>(false)

  return (
    <InView
      className="animatedLogo"
      onChange={(inView) => setAnimation(inView)}
    >
      <StyledLogo
        animate={animate}
        width="910"
        height="160"
        viewBox="0 0 910 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="bottom">
          <path d="M508 120.4H488V158.4H508V120.4Z" fill="white" />
          <path d="M566 158.4L550 120.4H528L544 158.4H566Z" fill="white" />
          <path
            d="M214.4 120.4C215.6 120.7 216.8 121.1 218 121.4C233 125.4 236 128.4 236 133.4V134.4C236 139.4 231 142.4 223 142.4C212 142.4 204 138.4 196 131.4L184 145.4C195 155.4 209 159.4 223 159.4C243 159.4 256 150.4 256 132.4V131.4C256 127.1 255.3 123.5 253.8 120.4H214.4Z"
            fill="white"
          />
          <path d="M20 120.4H0V158.4H20V120.4Z" fill="white" />
          <path d="M318 120.4H298V158.4H318V120.4Z" fill="white" />
          <path d="M413 120.4H393V158.4H413V120.4Z" fill="white" />
          <path d="M820 158.4H890V141.4H840V120.4H820V158.4Z" fill="white" />
          <path
            d="M156 158.4H176L160 120.4H96L80 158.4H100L108.9 137.4H147.2L156 158.4Z"
            fill="white"
          />
          <path
            d="M654 158.4H674L658 120.4H594L578 158.4H598L606.8 137.4H645.1L654 158.4Z"
            fill="white"
          />
          <path d="M713 120.4H693V158.4H713V120.4Z" fill="white" />
          <path d="M783 120.4H763V158.4H783V120.4Z" fill="white" />
        </g>
        <g className="top">
          <path
            d="M528 120.4C528 120.4 565.2 120.4 574.2 120.4C580.7 115.2 581.7 110.2 581.7 110.2L583 98.4C583 90.4 580.5 82.3 575.5 77.2C569.6 71.3 561 68.4 549 68.4H508L507.9 120.4H528V85.4H547C557 85.4 563.2 86.2 563.2 99.2C563.2 114.7 547 111.2 528 111.2C528 117.7 528 120.4 528 120.4Z"
            fill="white"
          />
          <path
            d="M528 120.4C528 120.4 565.2 120.4 574.2 120.4C580.7 115.2 581.7 110.2 581.7 110.2L583 98.4C583 90.4 580.5 82.3 575.5 77.2C569.6 71.3 561 68.4 549 68.4H508L507.9 120.4H528V85.4H547C557 85.4 563.2 86.2 563.2 99.2C563.2 114.7 547 111.2 528 111.2C528 117.7 528 120.4 528 120.4Z"
            fill="white"
          />
          <path
            d="M234.4 120.4H273.8C269.9 112.2 260.8 108 247 104.4C232 100.4 228 98.4 228 93.4V92.4C228 88.4 232 84.4 240 84.4C247 84.4 255 87.4 263 93.4L273 78.4C264 71.4 254 67.4 240 67.4C221 67.4 208 77.4 208 93.4V94.4C208 109.4 217.7 115.6 234.4 120.4Z"
            fill="white"
          />
          <path
            d="M290 68.4V85.4H318V120.4H338V85.4H366V68.4H290Z"
            fill="white"
          />
          <path d="M90 85.4V68.4H20V120.4H85V103.4H40V85.4H90Z" fill="white" />
          <path
            d="M483 85.4V68.4H413V120.4H478V103.4H433V85.4H483Z"
            fill="white"
          />
          <path
            d="M180 120.4L158 68.4H138L116 120.4H136L148 92.1L160 120.4H180Z"
            fill="white"
          />
          <path
            d="M910 85.4V68.4H840V120.4H903V103.4H860V85.4H910Z"
            fill="white"
          />
          <path
            d="M678 120.4L656 68.4H636L614 120.4H634L646 92.1L658 120.4H678Z"
            fill="white"
          />
          <path
            d="M781 68.4L758 101.4L735 68.4H713V120.4H733V99L748 120.4H768L783 99V120.4H803V68.4H781Z"
            fill="white"
          />
        </g>
        <path
          d="M28.4 9.1C28.2 8.5 28.3 7.8 28.4 7.4C28.6 6.4 29.3 5.3 31.3 5.3C33.1 5.3 34.2 6.4 34.2 8.2V10.2H42.1V8C42.1 1.1 35.9 0 31.4 0C25.8 0 21.2 1.9 20.4 7C20.2 8.4 20.1 9.7 20.5 11.3C21.9 17.8 33.1 19.6 34.7 23.7C35 24.5 34.9 25.4 34.8 26C34.5 27.1 33.8 28.1 31.7 28.1C29.7 28.1 28.5 27 28.5 25.2V22.2H20V24.6C20 31.7 25.5 33.8 31.5 33.8C37.2 33.8 41.9 31.9 42.7 26.6C43.1 23.9 42.8 22.1 42.7 21.4C41.3 14.8 29.3 12.8 28.4 9.1ZM131.1 9.2C131 8.6 131 7.9 131.1 7.6C131.3 6.6 132 5.5 134 5.5C135.8 5.5 136.9 6.6 136.9 8.3V10.2H144.7V8C144.7 1.2 138.6 0.1 134.2 0.1C128.6 0.1 124.1 1.9 123.3 7.1C123.1 8.5 123 9.7 123.4 11.3C124.8 17.7 135.9 19.5 137.5 23.6C137.8 24.4 137.7 25.3 137.6 25.9C137.4 27 136.7 28 134.6 28C132.6 28 131.5 26.9 131.5 25.2V22.2H123.1V24.6C123.1 31.6 128.6 33.7 134.5 33.7C140.1 33.7 144.8 31.8 145.5 26.5C145.9 23.8 145.6 22 145.4 21.4C143.9 14.8 132 12.9 131.1 9.2ZM202.8 26.4L195.4 1H183.7V32.3H191.5L191 6.1L199 32.3H210.2V1H202.4L202.8 26.4ZM53.8 1L47.9 32.6H56.4L60.8 3.4L65.1 32.6H73.6L67.8 1H53.8ZM101.5 1L97.5 25.7L93.5 1H80.6L79.9 32.6H87.8L88 3.4L93.4 32.6H101.4L106.8 3.4L107 32.6H114.9L114.2 1H101.5ZM174.9 1H166.9V24.4C166.9 24.8 166.9 25.3 166.8 25.6C166.6 26.4 166 27.9 163.8 27.9C161.6 27.9 160.9 26.4 160.8 25.6C160.7 25.3 160.7 24.8 160.7 24.4V1H152.7V23.6C152.7 24.2 152.7 25.4 152.8 25.7C153.4 31.6 158 33.5 163.8 33.5C169.6 33.5 174.3 31.6 174.8 25.7C174.8 25.4 174.9 24.2 174.9 23.6V1ZM229.8 14.9V19.5H233V24.1C233 24.5 233 24.9 232.9 25.3C232.8 26.2 232 27.6 229.7 27.6C227.4 27.6 226.6 26.1 226.5 25.3C226.4 24.9 226.4 24.5 226.4 24.1V9.6C226.4 9.1 226.4 8.5 226.5 8.1C226.7 7.3 227.3 5.8 229.6 5.8C232 5.8 232.6 7.4 232.8 8.1C232.9 8.6 232.9 9.3 232.9 9.3V11.1H240.9V10.1C240.9 10.1 240.9 9 240.8 8C240.2 2.1 235.3 0.2 229.7 0.2C224.1 0.2 219.3 2.1 218.6 8C218.5 8.5 218.4 9.5 218.4 10.1V23.4C218.4 24 218.4 24.4 218.5 25.5C219 31.3 224 33.3 229.6 33.3C235.2 33.3 240.2 31.3 240.7 25.5C240.8 24.4 240.8 24 240.8 23.4V14.9C240.8 14.9 229.8 14.9 229.8 14.9Z"
          fill="white"
        />
      </StyledLogo>
    </InView>
  )
}

export default AnimatedLogo
